import React from 'react'

const SvgClockArrowOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M20 11c0-4.963-4.037-9-9-9s-9 4.037-9 9 4.037 9 9 9a9.02 9.02 0 001.492-.124l-.86-.857a2.146 2.146 0 01-.515-.82L11 18.2c-3.97 0-7.2-3.23-7.2-7.2S7.03 3.8 11 3.8s7.2 3.23 7.2 7.2c0 .552-.063 1.09-.18 1.607l.02.02c.225.224.395.492.501.784l.808-.804.006-.006a2.15 2.15 0 01.564-.39c.053-.396.081-.8.081-1.211z' />
    <path d='M14.953 19.085l-1.37-1.364c-.102.04-.205.076-.31.111l1.394 1.387a9.22 9.22 0 00.286-.134zM11.905 7.143a.906.906 0 10-1.813 0l.002 4.494c0 .5.405.906.906.906h3.857a.906.906 0 100-1.813h-2.95l-.002-3.587z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.72 13.322a1.155 1.155 0 011.614.014 1.144 1.144 0 01.014 1.606l-.005.006-2.564 2.552 2.569 2.558a1.143 1.143 0 01-.014 1.606 1.155 1.155 0 01-1.615.014l-.006-.006-3.376-3.361a1.144 1.144 0 010-1.62l3.383-3.37zm4.329 0a1.154 1.154 0 011.614.014 1.144 1.144 0 01.014 1.606l-.006.006-2.563 2.552 2.568 2.558A1.143 1.143 0 0120.858 22a1.154 1.154 0 01-.81-.322l-.006-.006-3.376-3.361a1.144 1.144 0 010-1.62l3.383-3.37z'
    />
  </svg>
)

export default SvgClockArrowOutline
